export type SubmissionDetails =
  | {
      displayGrade?: string;
      submittedAt?: string;
    }
  | never;

export type InvalidAssignmentDetails = {
  hiddenFromStudent?: boolean;
  deletedAt?: string;
};

export type AssignmentDetails = {
  id: string;
  createdAt: string;
  isHidden: boolean;
  provider: string;
  status: string;
  title: string;
  submission?: SubmissionDetails;
  // start and end dates are optional
  // because manual assignments do not have them
  endDate?: string;
  startDate?: string;
  externalId: string;
  closedAt?: string;
  isAnonymised?: boolean;
  gradesReleasedAt?: string;
  updatedAt?: string;
  deletedAt?: string;
  groupSet?: string;
  extensionTitle?: string;
};

export interface AssignmentSelected {
  id: string;
}

export interface Assignment extends AssignmentSelected {
  title: string;
  provider: string;
  endDate?: string;
  startDate?: string;
  groupSet?: boolean;
  closedAt?: string;
}

export enum Provider {
  Handin = 'hand-in',
  TurnitIn = 'turnitin',
  Manual = 'manual',
  Quizzes = 'quizzes',
}

export const isKnownProvider = (provider: string): provider is Provider =>
  Object.values<string>(Provider).includes(provider);
